export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7946.5a16e43e.jpg";